import { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { KIND_CONFIG } from "./walletConfig";
import { FieldInput } from "./WalletShared";

/* Generic add/edit form driven by walletConfig — main fields visible, extra fields expandable. */
export function WalletItemForm({ kind, initial, onSaved, onCancel }) {
  const cfg = KIND_CONFIG[kind];
  const [form, setForm] = useState(() => ({ ...(initial || {}) }));
  const [busy, setBusy] = useState(false);
  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    const required = cfg.main[0].k;
    if (!String(form[required] || form.airline || "").trim()) {
      toast.error(`Please fill in "${cfg.main[0].l}" or the airline`); return;
    }
    setBusy(true);
    try {
      const payload = { ...form };
      if (Array.isArray(payload.benefits)) payload.benefits = payload.benefits.map((b) => b.trim()).filter(Boolean);
      await api.post(`/wallet/items/${kind}`, payload);
      toast.success(form.id ? `${cfg.label} updated` : `${cfg.label} added`);
      onSaved();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not save"); }
    setBusy(false);
  };

  return (
    <div className={`border ${cfg.border} bg-white p-4 mb-4`} data-testid={`wallet-form-${kind}`}>
      <div className="grid sm:grid-cols-2 gap-2">
        {cfg.main.map((f) => <FieldInput key={f.k} f={f} value={form[f.k]} onChange={setField} />)}
      </div>
      <details className="mt-3 group">
        <summary className="cursor-pointer text-xs font-700 text-primary list-none" data-testid={`wallet-form-more-${kind}`}>
          <span className="group-open:hidden">+ More details (routes, restrictions, terms…)</span>
          <span className="hidden group-open:inline">− Hide extra details</span>
        </summary>
        <div className="grid sm:grid-cols-2 gap-2 mt-2">
          {cfg.more.map((f) => <FieldInput key={f.k} f={f} value={form[f.k]} onChange={setField} />)}
        </div>
      </details>
      <div className="flex justify-end gap-2 mt-3">
        <button onClick={onCancel} className="px-4 py-2 border border-zinc-300 text-sm">Cancel</button>
        <button onClick={save} disabled={busy} data-testid={`wallet-save-${kind}`}
          className="px-4 py-2 bg-primary text-white text-sm font-600 hover:bg-blue-700 disabled:opacity-50">
          {form.id ? "Update" : "Save"} {cfg.label.toLowerCase()}
        </button>
      </div>
    </div>
  );
}
